// extracted by mini-css-extract-plugin
module.exports = {"DropDownBox__list":"DropDownList_DropDownBox__list__3LBSw"};